// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { PostApiPublicCommentReactionData, PostApiPublicCommentReactionResponse, PostPublicApiPublicCommentPostCommentComplaintData, PostPublicApiPublicCommentPostCommentComplaintResponse, GetApiPublicThreadInfoData, GetApiPublicThreadInfoResponse, GetApiPublicThreadCommentsData, GetApiPublicThreadCommentsResponse, GetApiPublicThreadStatsData, GetApiPublicThreadStatsResponse, GetApiPublicThreadsData, GetApiPublicThreadsResponse, PostPublicPostCommentData, PostPublicPostCommentResponse, PostPublicPostReplyData, PostPublicPostReplyResponse } from './types.gen';

/**
 * Post a new comment reaction
 * @param data The data for the request.
 * @param data.urn URN this reaction relates to
 * @param data.bu businessUnit (srf|rtr)
 * @param data.requestBody Input data format
 * @returns unknown Returned when created successfully
 * @throws ApiError
 */
export const postApiPublicCommentReaction = (data: PostApiPublicCommentReactionData): CancelablePromise<PostApiPublicCommentReactionResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/commentsapi/v1/public/{bu}/comments/{urn}/reactions',
    path: {
        urn: data.urn,
        bu: data.bu
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        400: 'Returned when already reacted to comment',
        404: 'Returned when comment was not found',
        500: 'Returned when reaction could not be saved'
    }
}); };

/**
 * Post a new complaint
 * @param data The data for the request.
 * @param data.urn URN this complaint relates to
 * @param data.bu
 * @returns void Returned when complaint is created successfully
 * @throws ApiError
 */
export const postPublicApiPublicCommentPostCommentComplaint = (data: PostPublicApiPublicCommentPostCommentComplaintData): CancelablePromise<PostPublicApiPublicCommentPostCommentComplaintResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/commentsapi/v1/public/{bu}/comments/{urn}/complaints',
    path: {
        urn: data.urn,
        bu: data.bu
    },
    errors: {
        404: 'Returned when comment was not found',
        409: 'Returned when user complains about comment more than once',
        500: 'Returned when complaint could not be saved'
    }
}); };

/**
 * Get a single thread by URN
 * @param data The data for the request.
 * @param data.bu businessUnit (srf|rtr)
 * @param data.urn Thread URN to fetch data for
 * @returns PublicThreadDto Returned when successful
 * @throws ApiError
 */
export const getApiPublicThreadInfo = (data: GetApiPublicThreadInfoData): CancelablePromise<GetApiPublicThreadInfoResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/commentsapi/v1/public/{bu}/threads/{urn}',
    path: {
        bu: data.bu,
        urn: data.urn
    },
    errors: {
        404: 'Returned when thread was not found'
    }
}); };

/**
 * Returns public comments for a specific thread
 * @param data The data for the request.
 * @param data.bu businessUnit (srf|rtr)
 * @param data.urn Thread URN to fetch comments data for
 * @param data.offset Offset
 * @param data.nextToken Next token (created-timestamp)
 * @param data.sort sort order (created|popular)
 * @param data.limit Limit
 * @returns unknown Returned when successful
 * @throws ApiError
 */
export const getApiPublicThreadComments = (data: GetApiPublicThreadCommentsData): CancelablePromise<GetApiPublicThreadCommentsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/commentsapi/v1/public/{bu}/threads/{urn}/comments',
    path: {
        bu: data.bu,
        urn: data.urn
    },
    query: {
        offset: data.offset,
        nextToken: data.nextToken,
        sort: data.sort,
        limit: data.limit
    },
    errors: {
        400: 'Returned when wrong parameters given (e.g. wrong order)',
        404: 'Returned when thread was not found'
    }
}); };

/**
 * Returns stats for a specific thread
 * @param data The data for the request.
 * @param data.bu businessUnit (srf|rtr)
 * @param data.urn Thread URN to fetch comments data for
 * @returns unknown Returned when successful
 * @throws ApiError
 */
export const getApiPublicThreadStats = (data: GetApiPublicThreadStatsData): CancelablePromise<GetApiPublicThreadStatsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/commentsapi/v1/public/{bu}/threads/{urn}/stats',
    path: {
        bu: data.bu,
        urn: data.urn
    },
    errors: {
        404: 'Returned when one of the threads was not found'
    }
}); };

/**
 * Returns a collection of public threads
 * @param data The data for the request.
 * @param data.bu businessUnit (srf|rtr)
 * @param data.nextToken Next token (created-timestamp)
 * @param data.limit Limit, max=25, default=25
 * @param data.created find records whose value of created equals given value<p>***Example***: 2025-01-13</p>
 * @param data.createdGt find records whose value of created is greater than given value<p>***Example***: 2025-01-13</p>
 * @param data.createdGte <p>***Example***: 2025-01-13</p>
 * @param data.createdLt find records whose value of created is lesser than given value<p>***Example***: 2025-01-13</p>
 * @param data.createdLte <p>***Example***: 2025-01-13</p>
 * @param data.createdNeq find records whose value of created do not equal given value<p>***Example***: 2025-01-13</p>
 * @param data.portal find records whose value of portal equals given value<p>***Example***: news</p>
 * @param data.portalIn Find records whose values of portal equals one of the given (comma-separated) set of values.<p>***Example***: news,sport</p>
 * @param data.sort **Deprecation note**: field _thread.state_ in sort is ***deprecated***
 * @param data.state find records whose value of state equals given value
 * @param data.stateIn Find records whose values of state equals one if the given (comma-separated) set of values. Allowed values: open,closed
 * @returns PublicResultPage Returned when successful
 * @throws ApiError
 */
export const getApiPublicThreads = (data: GetApiPublicThreadsData): CancelablePromise<GetApiPublicThreadsResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/commentsapi/v1/public/{bu}/threads',
    path: {
        bu: data.bu
    },
    query: {
        nextToken: data.nextToken,
        limit: data.limit,
        created: data.created,
        created__gt: data.createdGt,
        created__gte: data.createdGte,
        created__lt: data.createdLt,
        created__lte: data.createdLte,
        created__neq: data.createdNeq,
        portal: data.portal,
        portal__in: data.portalIn,
        sort: data.sort,
        state: data.state,
        state__in: data.stateIn
    }
}); };

/**
 * Post a new comment
 * @param data The data for the request.
 * @param data.bu businessUnit (srf|rtr)
 * @param data.requestBody Input data format
 * @returns ViewPublicComment Returned when created successfully
 * @throws ApiError
 */
export const postPublicPostComment = (data: PostPublicPostCommentData): CancelablePromise<PostPublicPostCommentResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/commentsapi/v1/{bu}/comments',
    path: {
        bu: data.bu
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        404: 'Returned when thread was not found'
    }
}); };

/**
 * Post a new reply
 * @param data The data for the request.
 * @param data.urn URN this new comment replies to
 * @param data.bu businessUnit (srf|rtr)
 * @param data.requestBody Input data format
 * @returns ViewPublicComment 201
 * @throws ApiError
 */
export const postPublicPostReply = (data: PostPublicPostReplyData): CancelablePromise<PostPublicPostReplyResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/commentsapi/v1/{bu}/comments/{urn}/replies',
    path: {
        urn: data.urn,
        bu: data.bu
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        404: 'Returned when parent comment was not found'
    }
}); };